export default function getRemainder(a: number, b: number){
    return a % b === 0
}